import starter from './app';
import './i18n';
import './lazyload-init';
import "./autocomplete"
import bsCustomFileInput from 'bs-custom-file-input';
window.bsCustomFileInput = bsCustomFileInput;

import Generic from '~/pages/Generic';
import Profilo from './pages/areariservata/Profilo';
import Documenti from './pages/areariservata/venditore/Documenti';
import Impersona from './pages/areariservata/Impersona';
import AdGestioneOfferte from './pages/areariservata/acquirente/AdGestioneOfferte';
import AdPropostaAcquisto from './pages/areariservata/acquirente/AdPropostaAcquisto';
import AtDomandaPartecipazione from './pages/areariservata/acquirente/AtDomandaPartecipazione';
import AdMonitoraVendita from '~/pages/areariservata/venditore/AdMonitoraVendita';
import AdCaricaPropostaControfirmata from '~/pages/areariservata/venditore/AdCaricaPropostaControfirmata';
import AtStatoAstaAcquirente from '~/pages/areariservata/acquirente/AtStatoAsta';
import AtStatoAstaVenditore from '~/pages/areariservata/venditore/AtStatoAsta';
import RicercheSalvate from '~/pages/areariservata/RicercheSalvate';
import VenditeSeguite from '~/pages/areariservata/VenditeSeguite';
import LeTueVendite from './pages/areariservata/venditore/LeTueVendite';
import ITuoiReport from './pages/areariservata/venditore/ITuoiReport';

let _ = starter({
    profilo: Profilo,
    impersona: Impersona, 
    documenti: Documenti,
    areariservata: Generic,
    adgestioneofferte: AdGestioneOfferte,
    adpropostaacquisto: AdPropostaAcquisto,
    atdomandapartecipazione: AtDomandaPartecipazione,
    admonitoravendita:AdMonitoraVendita,
    adcaricapropostacontrofirmata : AdCaricaPropostaControfirmata,
    atstatoastaacquirente : AtStatoAstaAcquirente,
    atstatoastavenditore : AtStatoAstaVenditore,
    ricerchesalvate: RicercheSalvate,
    venditeseguite: VenditeSeguite,
    letuevendite: LeTueVendite,
    ituoireport: ITuoiReport,
});


